import * as React from "react";
import {
  OverlayToaster,
  Position,
  type OverlayToaster as OverlayToasterType,
} from "@blueprintjs/core";

export interface ToastActions {
  showError: (message: string) => void;
}

const ToastActionsContext = React.createContext<ToastActions | undefined>(
  undefined
);

export const ToastProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const toaster = React.useRef<OverlayToasterType>(null);

  const actions = React.useMemo<ToastActions>(
    () => ({
      showError: (message: string) => {
        toaster.current?.show({
          message,
          intent: "danger",
          timeout: 5000,
        });
      },
    }),
    []
  );

  return (
    <ToastActionsContext.Provider value={actions}>
      <OverlayToaster position={Position.BOTTOM_RIGHT} ref={toaster} />
      {children}
    </ToastActionsContext.Provider>
  );
};

export const useToastActions = () => {
  const context = React.useContext(ToastActionsContext);
  if (context === undefined) {
    throw new Error("Must 'useToastActions' within a ToastProvider.");
  }
  return context;
};
